import { Header } from '@components/Header';
import { LinearProgressLoader } from '@components/core-ui/spinners/LinearProgressLoader';
import { useAPI } from '@providers/useAPI';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useListQueryParams } from 'app/hooks/useListQueryParams';
import { billingKeys } from 'app/queries/billing/billingKeys';

import { createFetchAdminAsOnePlansQueryFn } from '../../api/fetchAdminAsOnePlans';

import { Plans } from './components/Plans';

import { Wrapper } from './styles/Wrapper';

export const Content = () => {
  const { call } = useAPI();
  const queryClient = useQueryClient();
  const { search, setSearch } = useListQueryParams({
    defaults: { pageSize: 25, orderBy: 'createdAt', orderType: 'desc' },
  });

  const plansQuery = useQuery({
    queryKey: billingKeys.adminAsOnePlans(),
    queryFn: createFetchAdminAsOnePlansQueryFn(call),
  });

  const refreshPlans = () => {
    void queryClient.invalidateQueries({ queryKey: billingKeys.adminAsOnePlans() });
    void queryClient.invalidateQueries({ queryKey: billingKeys.asOnePlans() });
  };

  return (
    <>
      <Header title="Subscriptions" setSearch={setSearch} search={search} />

      <LinearProgressLoader active={plansQuery.isFetching} />
      <Wrapper>
        <Plans plans={plansQuery.data ?? []} onChange={refreshPlans} />
      </Wrapper>
    </>
  );
};
